export default __webpack_public_path__ + "static/media/aurora.c9e7b82d.jpeg";